import { space, typography, flexbox, layout, border, color, } from 'styled-system';
import styled from '../../../styles/styled';
export const BaseInput = styled.input(({ theme }) => ({
    backgroundColor: theme.colors.transparent,
    fontFamily: theme.text.bodyFontFamily,
    color: theme.colors.grey90,
    border: 'none',
    width: '100%',
    /*
     * outline: none is bad practice for a11y, but our inputs are wrapped in
     * other elements that should provide the focus styling. We don't have designs
     * these yet. TODO: Add 'focus' state styling to all inputs
     */
    outline: 'none',
    ':disabled': {
        cursor: 'not-allowed',
    },
}), color, border, space, typography, flexbox, layout);
//# sourceMappingURL=base_input.js.map